import src from "IMAGE";
export default { src, width: 537, height: 675, blurWidth: 0, blurHeight: 0};
